var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isOpenAddTicketAppDialog,
            width: "800px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
            top: "3vh",
            title: "Thêm gói phiếu bé ngoan App",
            border: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.isOpenAddTicketAppDialog = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "createTicketAppRequest",
              attrs: {
                "label-width": "140px",
                model: _vm.createTicketAppRequest,
                "label-position": "left",
                rules: _vm.rules,
              },
            },
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 15 } }, [
                    _c(
                      "div",
                      { staticClass: "grid-content" },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "Tên gói phiếu bé ngoan",
                              prop: "nameTicket",
                              "label-width": "170px",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                placeholder: "Nhập tên gói phiếu bé ngoan",
                              },
                              model: {
                                value: _vm.createTicketAppRequest.nameTicket,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.createTicketAppRequest,
                                    "nameTicket",
                                    $$v
                                  )
                                },
                                expression: "createTicketAppRequest.nameTicket",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 15 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "Mô tả",
                            prop: "descriptionTicket",
                            "label-width": "170px",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "Nhập mô tả" },
                            model: {
                              value:
                                _vm.createTicketAppRequest.descriptionTicket,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.createTicketAppRequest,
                                  "descriptionTicket",
                                  $$v
                                )
                              },
                              expression:
                                "createTicketAppRequest.descriptionTicket",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "Màn hình", "label-width": "170px" },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { placeholder: "Chọn màn hình" },
                              on: { change: _vm.handleChangeDisplayTicket },
                              model: {
                                value: _vm.displayTicket,
                                callback: function ($$v) {
                                  _vm.displayTicket = $$v
                                },
                                expression: "displayTicket",
                              },
                            },
                            _vm._l(_vm.listDisplayTicket, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                staticStyle: { width: "200px" },
                                attrs: { label: item.name, value: item.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticStyle: { "margin-left": "134px" } },
                [
                  _c(
                    "el-upload",
                    {
                      ref: "uploadTicket",
                      staticStyle: { "margin-left": "35px", clear: "both" },
                      attrs: {
                        action: "#",
                        "list-type": "picture-card",
                        "auto-upload": false,
                        "file-list": _vm.fileListTicket,
                        "on-change": _vm.handleChangePictureTicket,
                        "on-remove": _vm.handleRemoveTicket,
                        "before-remove": _vm.beforeRemove,
                        "on-preview": _vm.handlePictureCardPreviewTicket,
                        multiple: "",
                        accept: ".jpg,.jpeg,.png,.gif",
                      },
                    },
                    [
                      _c(
                        "i",
                        {
                          staticClass: "el-icon-plus",
                          staticStyle: { "white-space": "nowrap" },
                          attrs: { slot: "default" },
                          slot: "default",
                        },
                        [_vm._v("Thêm Ảnh")]
                      ),
                    ]
                  ),
                  _c(
                    "el-dialog",
                    {
                      attrs: { width: "50%", visible: _vm.dialogVisibleTicket },
                      on: {
                        "update:visible": function ($event) {
                          _vm.dialogVisibleTicket = $event
                        },
                      },
                    },
                    [
                      _c("img", {
                        attrs: {
                          width: "100%",
                          src: _vm.dialogImageUrlTicket,
                          alt: "",
                        },
                      }),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "tab-infor-button" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: {
                        type: "success",
                        size: "medium",
                        loading: _vm.loadingButton,
                        mini: "",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.submitForm("createTicketAppRequest")
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-check" }),
                      _c("span", [_vm._v("Lưu")]),
                    ]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger", size: "medium" },
                      on: {
                        click: function ($event) {
                          return _vm.closeDialog()
                        },
                      },
                    },
                    [
                      _c("i", { staticClass: "el-icon-circle-close" }),
                      _c("span", [_vm._v("Đóng")]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }